import { Rate } from 'types/Rate';

export const calculateTotalReviews = (rateData: Rate) => {
  return rateData
    ? (Object.keys(rateData) as Array<keyof typeof rateData>).reduce((acc, curr) => {
        return acc + rateData[curr];
      }, 0)
    : 0;
};

export const calculateFiveStarRating = (rate: Rate) => {
  return (
    (5 * rate.five_start + 4 * rate.four_start + 3 * rate.three_start + 2 * rate.two_start + 1 * rate.one_start) /
    calculateTotalReviews(rate)
  );
};
